import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { ButtonSelect, ButtonTextSelectControl } from '../../../Select'

import { QA_NAME_OVERVIEW_PERIOD_SELECT } from './RentalPortalOverviewPeriodSelect.constants'
import {
  getOverviewPeriodOption,
  getOverviewPeriodOptions,
} from './RentalPortalOverviewPeriodSelect.utils'

import * as styles from './RentalPortalOverviewPeriodSelect.module.css'

function RentalPortalOverviewPeriodSelect({ period, onSelect }) {
  const { t } = useTranslation()

  const options = getOverviewPeriodOptions(t)

  const servedOption = getOverviewPeriodOption({ options, period })

  function handleSelectItem(option) {
    onSelect(option.value)
  }

  return (
    <ButtonSelect
      Control={ButtonTextSelectControl}
      className={styles.RentalPortalOverviewPeriodSelect}
      controlProps={{
        buttonProps: {
          Button: Button.Outlined,
          height: BUTTON_HEIGHT_32,
          text: servedOption.label,
        },
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
        maxWidthByRef: false,
      }}
      dropdownProps={{ className: styles.dropdown }}
      filter={null}
      listProps={{ headerProps: { Search: null } }}
      options={options}
      qaName={QA_NAME_OVERVIEW_PERIOD_SELECT}
      value={servedOption}
      onSelectItem={handleSelectItem}
    />
  )
}

export default RentalPortalOverviewPeriodSelect
